import { InfoIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

import { ICON_WEIGHT } from './icon';
import { Popover } from './popover';

/**
 * An (i) that opens the detail behind a one-line summary.
 *
 * Settings and the fetch screen carried request counts, licence terms,
 * look-back windows and key-storage notes as paragraphs under every control.
 * All of it is true and some of it matters once — and it buried the controls
 * it was written about. The summary line stays; this holds the rest.
 */
export function InfoTip({ label, children }: { label: string; children: ReactNode }) {
  return (
    <Popover
      align="left"
      panelClassName="w-80 max-w-[calc(100vw-2rem)] space-y-2 p-3 text-xs leading-relaxed text-muted-foreground"
      trigger={({ open, toggle }) => (
        <button
          type="button"
          aria-label={label}
          aria-expanded={open}
          onClick={toggle}
          className="rounded-control text-muted-foreground hover:text-foreground inline-flex size-5 items-center justify-center align-middle"
        >
          <InfoIcon aria-hidden="true" weight={ICON_WEIGHT} className="size-4" />
        </button>
      )}
    >
      {children}
    </Popover>
  );
}
